export const contato = {
  hero: {
    label: 'Contato',
    title: 'Fale com a FGT Capital',
    subtitle: 'Entre em contato para agendar um diagnóstico estratégico ou esclarecer dúvidas sobre engenharia patrimonial.',
  },
  info: {
    title: 'Informações de Contato',
    location: {
      label: 'Localização',
      value: 'São Paulo/SP – Brasil',
    },
    whatsapp: {
      label: 'WhatsApp',
      value: '+55 11 93032-2408',
    },
    email: {
      label: 'E-mail',
      value: 'contato@fgt-capital.com',
    },
    hours: {
      label: 'Horário',
      value: 'Segunda a Sexta, 9h às 18h',
    },
  },
  form: {
    title: 'Envie uma Mensagem',
    fields: {
      name: 'Nome Completo',
      email: 'E-mail',
      whatsapp: 'WhatsApp',
      message: 'Mensagem',
      characters: 'caracteres',
    },
    submit: 'Enviar Mensagem',
    submitting: 'Enviando...',
    success: 'Mensagem enviada com sucesso! Retornaremos em breve.',
    error: 'Erro ao enviar mensagem. Tente novamente ou entre em contato via WhatsApp.',
  },
};